import { render, staticRenderFns } from "./_page.vue?vue&type=template&id=2297f10f&"
import script from "./_page.vue?vue&type=script&lang=ts&"
export * from "./_page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports